import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  bgColor: "背景颜色",
  clipSize: "裁剪方式",
  repeatType: "重复方式",
  alignType: "对齐方式",
  opacity: "透明度",
  boxShadowColor: "边框阴影颜色",
  boxShadowH: "阴影x轴的偏移量",
  boxShadowV: "阴影y轴的偏移量",
  boxShadowBlur: "阴影模糊值",
  boxShadowSpread: "阴影扩散值",
  iconWidth: "图标大小",
  iconSrc: "图标链接",
  iconType: "图标类型", // img icon
  iconColor: "图标颜色",
  iconColorIsThemeColor: "图标颜色跟随主题色",
  "boxShadowColor.0": "阴影颜色1",
  "animateSets.animateType": "动画类型",
  "animateSets.animateDirection": "动画方向",
  "animateSets.animateDuration": "动画持续时间"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
